// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Risorse ======
function renderRisorse() {
  const tbody = $('#tbodyRisorse');
  if (!tbody) return; // vista risorse (lazy) non ancora montata
  wireRisorseView();
  // G4: empty state ricco se nessuna risorsa
  if (!state.resources.length) {
    if (typeof emptyState === 'function') {
      emptyState(tbody, 5, {
        title: 'Nessuna risorsa nel team',
        message: 'Aggiungi le risorse Ma.Se. per iniziare a mappare gli accessi.',
        ctaLabel: isAdmin() ? '+ Nuova risorsa' : null,
        onCta: () => document.getElementById('btnAddRisorsa')?.click()
      });
      return;
    }
  }
  tbody.innerHTML = state.resources
    .map((r) => {
      let attivi = 0,
        richieste = 0,
        daRich = 0;
      state.clients.forEach((c) => {
        const v = (c.accessi || {})[r];
        if (!v) return;
        const k = v.toLowerCase().trim();
        if (k === 'sì' || k === 'si') attivi++;
        else if (k === 'richieste') richieste++;
        else if (k === 'da richiedere') daRich++;
      });
      const delBtn = isAdmin()
        ? `<button class="btn btn-icon admin-only" data-del="${escapeHtml(r)}" title="Rimuovi">✕</button>`
        : '';
      return `
      <tr data-risorsa="${escapeHtml(r)}" title="Apri detail risorsa">
        <td data-label="Risorsa"><strong>${escapeHtml(r)}</strong></td>
        <td data-label="Attivi"><span class="status status-si">${attivi}</span></td>
        <td data-label="Richieste"><span class="status status-richieste">${richieste}</span></td>
        <td data-label="Da richiedere"><span class="status status-darichiedere">${daRich}</span></td>
        <td class="tcell-min">${delBtn}</td>
      </tr>`;
    })
    .join('');

  // Click sulla riga apre la vista detail (ignora click sul pulsante elimina)
  tbody.querySelectorAll('tr[data-risorsa]').forEach((tr) => {
    tr.addEventListener('click', (e) => {
      if (e.target.closest('[data-del]')) return;
      openRisorsaDetail(tr.dataset.risorsa);
    });
  });

  tbody.querySelectorAll('[data-del]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.stopPropagation();
      if (!isAdmin()) return;
      const r = btn.dataset.del;
      const clientiCoinvolti = state.clients.filter((c) => c.accessi && r in c.accessi).length;
      const ok = await confirmAction({
        level: 'warning',
        title: 'Rimuovere risorsa dal team',
        message: `Stai per rimuovere "${r}" dal team Ma.Se.`,
        details: [
          `Le colonne di accesso di ${r} verranno cancellate su tutti i clienti`,
          clientiCoinvolti
            ? `${clientiCoinvolti} client${clientiCoinvolti === 1 ? 'e' : 'i'} con accessi mappati`
            : 'Nessun cliente ha accessi mappati a questa risorsa',
          'Lo storico delle modifiche resta intatto'
        ],
        warning: clientiCoinvolti
          ? 'I dati sugli accessi specifici di questa risorsa andranno persi.'
          : '',
        confirmText: 'Rimuovi risorsa'
      });
      if (!ok) return;
      try {
        await api.deleteResource(r);
        await loadStateFromSupabase();
        logAudit({
          action: 'delete',
          entity: 'Risorsa',
          target: r,
          details: 'Risorsa rimossa dal team'
        });
        renderAll();
        toast('Risorsa rimossa');
      } catch (err) {
        console.error(err);
        toast('Errore rimozione: ' + (err.message || err));
      }
    });
  });
}

// Il bottone "+ Nuova risorsa" vive nella vista risorse (ora lazy): wiring
// mount-safe e idempotente, rieseguito dopo l'iniezione del fragment.
function wireRisorseView() {
  bindOnce(document.getElementById('btnAddRisorsa'), 'click', () => {
    if (!isAdmin()) return;
    document.getElementById('modalRisorsa').classList.remove('hidden');
    // Dirty guard: il form e' dirty se l'input nome ha del testo
    if (typeof registerDirtyGuard === 'function') {
      registerDirtyGuard(
        'modal-risorsa',
        () => !!document.querySelector('#formRisorsa input[name="nome"]')?.value.trim(),
        'Nuova risorsa'
      );
    }
  });
}
document.addEventListener('DOMContentLoaded', wireRisorseView);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'risorse') wireRisorseView();
});

document.getElementById('formRisorsa').addEventListener('submit', async (e) => {
  e.preventDefault();
  if (!isAdmin()) return;
  const nome = e.target.nome.value.trim();
  if (!nome) return;
  if (state.resources.includes(nome)) {
    toast('Risorsa già presente');
    return;
  }
  try {
    await api.addResource(nome);
    await loadStateFromSupabase();
    logAudit({
      action: 'create',
      entity: 'Risorsa',
      target: nome,
      details: 'Risorsa aggiunta al team'
    });
    e.target.reset();
    closeModals();
    toast('Risorsa aggiunta');
    renderAll();
  } catch (err) {
    console.error(err);
    toast('Errore aggiunta: ' + (err.message || err));
  }
});

Object.assign(globalThis, { renderRisorse, wireRisorseView });
export {};
